// UserProtectedRoute.js
import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import PageSkeleton from "../../../components/ui/PageSkeleton";

const UserProtectedRoute = () => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-surface" role="status" aria-live="polite">
        <div className="p-4 sm:p-6">
          <PageSkeleton />
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        state={{ from: location.pathname, redirectBack: true }}
        replace
      />
    );
  }

  return <Outlet />;
};

export default UserProtectedRoute;
